import React, { useState, useEffect } from 'react';
import { useInput, required } from 'react-admin';
import AceEditor from "react-ace";
import 'brace/ext/searchbox';
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";

const JavascriptInput = (props) => {
    const { onChange, onBlur, ...rest } = props;
    const [value, setValue] = useState('');
    const {
        field,
        fieldState: { isTouched, invalid, error },
        formState: { isSubmitted },
        isRequired, 
    } = useInput({onChange, onBlur, ...props})

    useEffect(() => {
        // let n = props.source
        // console.log('field', field)
        // if(n.indexOf('.'))
        //     n = n.substring(n.lastIndexOf('.')+1, n.length)
        // setValue(field.value)
        // console.log('props.record[n] - ' + n, props.record[n])
        // console.log('name - ' + name, props.record)
        // console.log('props', props)
    }, [props])

    const handleChange = (code) => {
        setValue(code)
        onChange(code);
    }
    

    return (
        <AceEditor
            {...field}
            width={'100%'}
            height={props.height?props.height:'800px'}
            placeholder={props.label}
            mode="javascript"
            theme="github"
            name="blah2"
            // onChange={newValue=>{handleChange(newValue)}}
            fontSize={14}
            showPrintMargin={true}
            showGutter={true}
            highlightActiveLine={true}
            // value={value}
            setOptions={{
                useWorker: false,
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false,
                enableSnippets: false,
                showLineNumbers: true,
                tabSize: 2,
            }}/>
    )
};



export default JavascriptInput;